"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatRate = exports.formatHours = void 0;
const padCents = cents => {
  const fullStr = "00".concat(cents);
  return fullStr.substr(fullStr.length - 2);
};
const formatRate = rate => {
  const dollars = Math.floor(rate);
  const cents = rate % 1 * 100;
  return "$".concat(dollars, ".").concat(padCents(cents));
};
exports.formatRate = formatRate;
const formatHours = hrs => parseFloat(Math.round(hrs * 10) / 10).toFixed(1);
exports.formatHours = formatHours;